import { Config } from "../config/Config";

export const Routes = {
    Home: Config?.url + '/',
    PageNotFound:Config?.url + '*',
    Login: Config?.url + '/login',
    Signup:Config.url + '/signup',
    Profile:Config.url + '/profile',
    Faq:Config.url +'/faq',
    Cma:Config.url +'/cms',
    CMS:Config.url + '/user/privacy-policy/:id',
    AppPrivacyPolicyCMS:Config.url ="/user/privacy-policy/:id", 
    AppTermCondition:Config.url ="/user/terms-and-conditions/:id", 
    AppAboutUs:Config.url ="/user/about-us/:id", 
    UserFaq:Config.url ="/user/faq/:id",
    SelectAddress:Config.url ="/select-address",
    SelectExcel:Config.url ='/select-excel-address',
    RequestQuoteCreate:Config.url ="/create-request-quote",
    RequestQuoteCreateSecond:Config.url ="/incorrect-excel",
    MyQuote:Config.url ="/my-quotation",
    Viewquote:Config.url ="/view-quotation/:id",
    Order:Config.url ="/order",
    OrderDetail:Config.url ="/order-detail/:id",
    Notification:Config.url ="/notification",
    QutationHistory:Config.url ="/history/:id",
    AddressList:Config.url ='/address',
    CategoryList:Config.url ='/category',
    UpdatecategoryList:Config.url ='/update-category',
    Paymentsuccess:Config.url = "/success",
    Paymentscancel:Config.url = "/cancel"

}
